import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import * as temp from 'moment';
const moment = temp['default'];
import {BehaviorSubject, Observable, Observer, Subject, Subscription} from 'rxjs';
import { emtrConstant } from '../../../constants/emtrConstants';
import { RuleService } from '../../../services/rule-service/rule.service';
import { FormDataService, SharedService, SharedConstant} from '@ems/shared';
import { SecurityTypeComponent } from '../../security-type/security-type.component';
import { EmtrService } from '../../../emtr.service';
import { DeleteConfirmationModalComponent } from '../../../delete-confirmation-modal/delete-confirmation-modal.component';

@Component({
  selector: 'tr-rules-step2-select-attributes',
  templateUrl: './rules-step2.component.html'
})
export class RulesStep2Component implements OnInit, OnDestroy {

  getConstant = emtrConstant;
  getSharedConstant = SharedConstant;

  @ViewChild('confirmationMessage', { static: true }) confirmationMessage: any;
  @ViewChild('child', { static: true }) childSecurityType: SecurityTypeComponent;
  @ViewChild(DeleteConfirmationModalComponent) modifyOrVoilationConfirmationModal: DeleteConfirmationModalComponent;

  currentOrgSubscription: Subscription;
  isInValidFromDate = false;
  isPastFromDate = false;
  isInValidToDate = false;
  isPastToDate = false;
  errorMsg = [];
  dateErrorMsg = '';
  indSecsDuplicateErrMsg = '';
  componentName = [];

  attributesForm: FormGroup = this.fb.group({
    dateTo: this.fb.group({
      date: ['', Validators.required],
      time: ['', Validators.required],
      timeMeridian: ['', Validators.required]
    }),
    dateFrom: this.fb.group({
      date: ['', Validators.required],
      time: ['', Validators.required],
      timeMeridian: ['', Validators.required]
    }),
    datepickerDisabled: false,
    restrictBuys: '',
    restrictSells: '',
    restrictShortSells: '',
    validateRestrictType: ['', Validators.required],
    description: '',
    notes: '',
    changeRequestId: '',
    indSecs: [[], Validators.required],
    instGrps: [[], Validators.required],
    fndFmlyInfo: [[], Validators.required],
    appliesTo: ['', Validators.required],
    autoCompleteData: [],
    chooseSecurityType: [{}, Validators.required],
    assetGroups: []
  });
  indSecsDuplicateErr: any = '';
  dateError: any = '';
  attributesFormData: any;
  appliesType: any = {};
  multiselectSelectedData: any;
  multiselectSelectedInstGrpData: any;
  multiLevelUpdatedList: any = {};
  multiLevelSecurityType: any;
  showIndividualSecurity = false;
  dateSelectionType: any = 'date';
  message: string;
  isClicked = true;
  defaultSaveSuccess: any;
  securityData = [];
  selectedSecurityType = false;
  attributeData: any;
  localObserver = new Subject<boolean>();
  confirmMessage: any;
  fromDateDisabled: any = false;
  is10b5Client = false;
  selectedInstrumentGroups = false;
  selectedIndividualSecurity = false;
  warningMsg = '';
  presetRuleId: any;
  initialPresetRuleId: any;
  assetGroups: any;
  selectedDropDownVal: any;
  presetRuleKey: any;
  businessUnit: any;
  formObjToCompare: any;
  allSecCategories = [];
  setMicAGFlag = false;
  viewIG: any;
  showSecurityOrPreset: any = '';
  presetRuleWarnMsg: any;
  displayRadioButtonsForRestSecType: any;
  assetGroupsInput = [];
  presetRuleRadioBtnLabel: any = '';
  customVal = false;
  validateGlobalSemiGlobalRuleMsg: any = '';
  removeSuccessMsg = false;
  ruleData ='';
  invalidErrorMessage = new BehaviorSubject<string>('');
  globalSemiGlobalConfirmationMsg: string;
  isModified = false;
  isViolated = false;
  disableSaveAfterError = false;
  saveErrorSubscription: Subscription;

  /* eslint-disable-next-line max-len */
  constructor(public fb: FormBuilder, public router: Router, public formDataService: FormDataService, private r: ActivatedRoute, public ruleService: RuleService, @Inject('commonConstants') public commonConstants, public sharedService: SharedService, @Inject('entitlementConst') public entitlementConst, public emtrService: EmtrService) {
    this.attributeData = { ...this.formDataService.getFormData() };
    this.attributesFormData = this.attributeData;
    this.currentOrgSubscription = this.sharedService.clientInformation.subscribe(clientInfo => {
      this.businessUnit = clientInfo && clientInfo.businessUnit;
    });
    this.presetRuleRadioBtnLabel = (this.businessUnit === this.getSharedConstant.rbsBUText || this.businessUnit === '') ? this.getConstant.presetRules.tradingMenu: this.getConstant.presetRules.assetGroupText;
    this.presetRuleWarnMsg = (this.businessUnit === this.getSharedConstant.rbsBUText || this.businessUnit === '')? this.warningMessagePresetRules(): this.getSharedConstant.DBS.warningMsgForPresetRulesOrSecurities;
    this.viewIG = (this.attributeData.mode === 'EDIT') && this.businessUnit === 'DBS' && (this.attributesFormData.instrumentGroups && this.attributesFormData.instrumentGroups.length > 0);
    this.displayRadioButtonsForRestSecType = formDataService.formData.ruleSubCategory === '10b5-1' || this.attributesFormData.rulesCategory === this.getConstant.rulesConstant.ruleTypeLabels.WATCH_LST_ENGText;
    this.allSecCategories.push(this.attributesFormData.secCatgs1);
    this.allSecCategories.push(this.attributesFormData.secCatgs2);
    this.allSecCategories.push(this.attributesFormData.secCatgs3);
    /* Selected Type is Security-Type removed appliesTo and AutoComplete*/
    if (this.attributesFormData.assetGroups && this.attributesFormData.assetGroups.length > 0) {
      this.showSecurityOrPreset = this.getConstant.ruleSteps.step2.step2PresetRuleConditionText;
      if (this.businessUnit !== this.getSharedConstant.spsBUText && this.attributesFormData.rulesCategory !== this.getConstant.rulesConstant.ruleTypeLabels.WATCH_LST_ENGText) {
      this.displayWarningMsg();
      }
    } else if ((this.attributesFormData.secCatgs1 && this.attributesFormData.secCatgs1.length > 0) || (this.attributesFormData.secCatgs2 && this.attributesFormData.secCatgs2.length > 0) || (this.attributesFormData.secCatgs3 && this.attributesFormData.secCatgs3.length > 0)) {
      this.showSecurityOrPreset = 'secLevel';
      if (this.businessUnit !== this.getSharedConstant.spsBUText && this.attributesFormData.rulesCategory !== this.getConstant.rulesConstant.ruleTypeLabels.WATCH_LST_ENGText) {
      this.displayWarningMsg();
      }
    }
    this.assetGroupsInput = this.attributesFormData.assetGroups;
    this.populateData();
  }

  ngOnInit() {
    this.confirmMessage = this.confirmationMessage.confirmMessage;
    this.removeValidatorsForFundFamily();
    this.is10b5Client = this.sharedService.get10b5ClientDetails();
    /* Open Brokerage changes for creation */
    if(this.formDataService.formData.mode === '') {
      this.toCreateOBPRuleAttributes();
    }
    this.superRestriction();
    if (this.formDataService.formData.mode === this.getConstant.rulesConstant.editCapsTxt && this.validateRoleForOBP()) {
      this.showSecurityOrPreset = this.getConstant.ruleSteps.step2.step2PresetRuleConditionText;
      this.attributeData.micAGSelectedFlag = false;
    }
    /* Prefetch asset groups for SPS so we can determine if digital asset data exists before showing radio buttons */
    if (this.businessUnit === this.getSharedConstant.spsBUText && this.ruleService.assetGrpCache().length === 0) {
      this.ruleService.getAssetGroups().subscribe(assetGrp => {
        this.ruleService.setAssetGrpCacheData(assetGrp.data);
      });
    }
    /* Re-enable the Save & Continue button and clear the related error banner once the user makes any change after a save error in edit mode */
    this.saveErrorSubscription = this.attributesForm.valueChanges.subscribe(() => {
      if (this.disableSaveAfterError) {
        this.disableSaveAfterError = false;
        this.ruleService.showSchError.emit(false);
        this.ruleService.schErrorMsg.emit([]);
        this.invalidErrorMessage.next('');
        this.sharedService.clearErrorMessage();
      }
    });
  }

  removeValidatorsForFundFamily() {
    if (this.attributesFormData && this.attributesFormData.ruleType === this.getConstant.rulesConstant.autoComplete.FNDISUTxt) {
      const appliesToTxt = 'appliesTo';
      this.attributesForm.controls[appliesToTxt].clearValidators();
      this.attributesForm.controls[appliesToTxt].updateValueAndValidity();
      const indSecsTxt = 'indSecs';
      this.attributesForm.controls[indSecsTxt].clearValidators();
      this.attributesForm.controls[indSecsTxt].updateValueAndValidity();
    } else {
      const fundFamilyInfoTxt = 'fndFmlyInfo';
      this.attributesForm.controls[fundFamilyInfoTxt].clearValidators();
      this.attributesForm.controls[fundFamilyInfoTxt].updateValueAndValidity();
    }
    const inst = 'instGrps';
    if (!this.sharedService.checkEntitlements(this.entitlementConst.navUUID.emtrAccess.instrumentsSummary.uuid, '', '') || !(this.attributesFormData.ruleType === 'INDSEC' && this.attributesFormData.rulesCategory === this.getConstant.rulesConstant.autoComplete.RESTRICT_LST_ENGTxt)) {
      if (this.attributesForm.controls[inst]) {
        this.attributesForm.controls[inst].clearValidators();
        this.attributesForm.updateValueAndValidity();
      }
    }
  }

  calendarValidation(value) {
    if (value.dateLabel === this.getConstant.rulesConstant.startDate) {
      this.isInValidFromDate = value.isInValidDate;
      this.isPastFromDate = value.isPastDate;
    } else if (value.dateLabel === this.getConstant.rulesConstant.endDate) {
      this.isInValidToDate = value.isInValidDate;
      this.isPastToDate = value.isPastDate;
    }

    /*To show 'Please enter a valid date MM/DD/YYYY' error msg*/
    if (this.isInValidFromDate || this.isInValidToDate) {
      if (this.errorMsg.indexOf(this.getConstant.inValidDateMessage) === -1) {
        this.errorMsg.push(this.getConstant.inValidDateMessage);
      }
      this.ruleService.showSchError.emit(true);
    } else {
      if (this.errorMsg.indexOf(this.getConstant.inValidDateMessage) !== -1) {
        this.errorMsg.splice(this.errorMsg.indexOf(this.getConstant.inValidDateMessage), 1);
      }
    }

    /*To show 'From Date should be Current or Future Date' error msg*/
    if (this.isPastFromDate) {
      if (this.errorMsg.indexOf(this.getConstant.pastFromDateMessage) === -1) {
        this.errorMsg.push(this.getConstant.pastFromDateMessage);
      }
      this.ruleService.showSchError.emit(true);
    } else {
      if (this.errorMsg.indexOf(this.getConstant.pastFromDateMessage) !== -1) {
        this.errorMsg.splice(this.errorMsg.indexOf(this.getConstant.pastFromDateMessage), 1);
      }
    }

    /*To show 'To Date should be Current or Future Date' error msg*/
    if (this.isPastToDate) {
      if (this.errorMsg.indexOf(this.getConstant.pastToDateMessage) === -1) {
        this.errorMsg.push(this.getConstant.pastToDateMessage);
      }
      this.ruleService.showSchError.emit(true);
    } else {
      if (this.errorMsg.indexOf(this.getConstant.pastToDateMessage) !== -1) {
        this.errorMsg.splice(this.errorMsg.indexOf(this.getConstant.pastToDateMessage), 1);
      }
    }

    /*Hide the error block when errorMsg is empty*/
    if (this.errorMsg.length === 0) {
      this.ruleService.showSchError.emit(false);
    }

    this.ruleService.schErrorMsg.emit(this.errorMsg);
  }

  get hasDigitalAssetData(): boolean {
    return this.ruleService.assetGrpCache().some(val => val.code === this.getConstant.ruleSteps.step2.digitalAssetGroupCode);
  }

  get globalSemiGlobalInformationMsg(): string {
    const step2 = this.getConstant.ruleSteps.step2;
    const isSuperRestriction = this.attributesFormData?.isSuperRestriction === 'Y';
    const globalRuleValue = this.attributesFormData?.globalRule;
    const isGlobalRule = globalRuleValue === true || globalRuleValue === 'Y';
    if (isSuperRestriction && !isGlobalRule) {
      return step2.superRuleInformationMsg;
    } else if (isSuperRestriction && isGlobalRule) {
      return step2.superSemiGlobalRuleInformationMsg;
    } else {
      return step2.informationMsg;
    }
  }

  canDeactivate(event, observer) {
    this.confirmMessage.message = this.confirmMessage.message ? this.confirmMessage.message : this.getConstant.rulesConstant.confirmationMessage.menuClickMsg;
    if (this.isClicked) {
      this.localObserver = observer;
      return this.confirmationMessage.showConfirmMsg(this.confirmMessage, observer);
    }
    return true;
  }

  populateData() {
    if (this.attributesFormData.ruleType === 'SECTYP') {
      this.showIndividualSecurity = true;
      this.attributesForm.removeControl('indSecs');
      this.attributesForm.removeControl('instGrps');
      this.attributesForm.removeControl('appliesTo');
    } else {
      this.attributesForm.removeControl('chooseSecurityType');
      this.showIndividualSecurity = false;
    }
    this.attributesFormData.startDt = (this.attributesFormData.startDt) ? this.attributesFormData.startDt : '';

    this.attributesFormData.endDt = (this.attributesFormData.endDt) ? this.attributesFormData.endDt : '';

    this.attributesFormData.indSecs = (this.attributesFormData.indSecs) ? this.attributesFormData.indSecs : [];
    this.attributesFormData.instrumentGroups = (this.attributesFormData.instrumentGroups) ? this.attributesFormData.instrumentGroups : [];

    this.attributesFormData.indSecs.length > 0 ? this.selectedIndividualSecurity = true : this.selectedIndividualSecurity = false;
    this.attributesFormData.instrumentGroups.length > 0 ? this.selectedInstrumentGroups = true : this.selectedInstrumentGroups = false;
    this.attributesFormData.fndFmlyInfo = (this.attributesFormData.fndFmlyInfo.length > 0) ? this.attributesFormData.fndFmlyInfo : [];

    /* Preserve initial preset selection for robust change detection in edit/copy flows.
       initialPresetRuleId is captured ONCE here and never reassigned afterwards;
       compareFormDataValue() is its only consumer for preset diff checks. */
    this.presetRuleId = this.attributesFormData.presetRuleId;
    this.initialPresetRuleId = this.attributesFormData.presetRuleId;

    this.attributesForm.patchValue({
      datepickerDisabled: (this.attributesFormData.endDt) ? true : '',
      dateTo: {
        date: (this.attributesFormData.endDt) ? new Date(this.attributesFormData.endDt) : null,
        time: (this.attributesFormData.endDt) ? moment(this.attributesFormData.endDt).format('hh:mm') : null,
        timeMeridian: (this.attributesFormData.endDt) ? moment(this.attributesFormData.endDt).format('a').toUpperCase() : null
      },
      dateFrom: {
        date: (this.attributesFormData.startDt) ? new Date(this.attributesFormData.startDt) : '',
        time: (this.attributesFormData.startDt) ? moment(this.attributesFormData.startDt).format('hh:mm') : '',
        timeMeridian: (this.attributesFormData.startDt) ? moment(this.attributesFormData.startDt).format('a').toUpperCase() : ''
      },
      description: this.attributesFormData.desc,
      notes: this.attributesFormData.note,
      changeRequestId: this.attributesFormData.changeRequestId,
      restrictSells: (this.attributesFormData.rstrctSell === 'Y'),
      restrictBuys: (this.attributesFormData.rstrctBuy === 'Y'),
      restrictShortSells: (this.attributesFormData.rstrctShortSell === 'Y'),
      indSecs: this.attributesFormData.indSecs,
      instGrps: this.attributesFormData.instrumentGroups,
      fndFmlyInfo: this.attributesFormData.fndFmlyInfo,
      appliesTo: this.attributesFormData.appliesTo,
      chooseSecurityType: this.updateSecurityValues(this.attributesFormData.chooseSecurityType),
      validateRestrictType: (this.attributesFormData.rstrctSell === 'Y' || this.attributesFormData.rstrctBuy === 'Y'
        || this.attributesFormData.rstrctShortSell === 'Y') ? true : '',
      assetGroups: this.attributesFormData.assetGroups ? this.attributesFormData.assetGroups : ''
    });
    this.disableOBPInEditMode();
    this.applySuperRestrictionDefaults();
    this.multiselectSelectedData = (this.attributesFormData.securityType) ? this.attributesFormData.securityType : [];
    this.appliesType.individualSecurities = this.attributesFormData.appliesTo === 'BTH' || this.attributesFormData.appliesTo === 'IND';
    this.appliesType.underlyingOptions = this.attributesFormData.appliesTo === 'BTH' || this.attributesFormData.appliesTo === 'OPT' || this.attributesFormData.appliesTo === 'DV';
    this.attributesFormData.rulesCategory = (this.attributesFormData.override === 'Y') ? 'Override' : this.attributesFormData.rulesCategory;
    /* eslint-disable-next-line max-len */
    if (this.attributesFormData.mode && this.attributesFormData.ruleType === 'SECTYP' && !Object.keys(this.multiLevelUpdatedList).length) {
      this.populateSecurityTypeData();
    }
    /* disable date for status ACTIVE and EXPIRED */
    if (this.attributesFormData.status === 'ACTIVE') {
      this.attributesForm.get('dateFrom').disable({ onlySelf: true });
      this.fromDateDisabled = true;
    } else if (this.attributesFormData.status === 'EXPIRED') {
      this.fromDateDisabled = true;
      this.attributesForm.get('dateFrom').disable({ onlySelf: true });
      setTimeout(() => {
        this.attributesForm.get('dateTo').disable({ onlySelf: true });
      }, 10);
      this.attributesForm.get('datepickerDisabled').disable({ onlySelf: true });
    }
    this.formObjToCompare = this.attributesForm.getRawValue();
    delete this.formObjToCompare.chooseSecurityType;
  }

  updateAppliesto(appliesTo) {
    const isRBSOrGlobal = this.businessUnit === this.getSharedConstant.rbsBUText || this.attributesFormData.globalRule;
    const appliesToValidate = (appliesTo && appliesTo.individualSecurities && appliesTo.underlyingOptions) ? 'BTH' :
      (appliesTo && appliesTo.individualSecurities) ? 'IND' : (appliesTo && appliesTo.underlyingOptions) ? (isRBSOrGlobal ? 'DV' : 'OPT') : '';
    this.attributesForm.patchValue({ appliesTo: appliesToValidate });
    this.attributesFormData.appliesTo = appliesToValidate;
    this.attributesForm.markAsDirty();
  }

  updateIndividualSecurities(securities) {
    if (this.attributesFormData && this.attributesFormData.ruleType !== this.getConstant.rulesConstant.autoComplete.FNDISUTxt) {
      this.attributesForm.patchValue({ indSecs: securities });
      /* Setting the Form to Dirty if Autocomplete Record is selected */
      this.attributesForm.markAsDirty();
      if (this.attributesForm.get('indSecs').value && this.attributesForm.get('indSecs').value.length > 0) {
        this.selectedIndividualSecurity = true;
      } else {
        this.selectedIndividualSecurity = false;
      }
    } else {
      this.attributesForm.patchValue({ fndFmlyInfo: securities });
      /* Setting the Form to Dirty if Autocomplete Record is selected */
      this.attributesForm.markAsDirty();
    }
  }

  deleteFormValues() {
    const ruleObj: any = { ...this.formDataService.getFormData() };
    if (this.attributesFormData.ruleType !== 'SECTYP') {
      delete ruleObj.secCatgs1;
      delete ruleObj.secCatgs2;
      delete ruleObj.secCatgs3;
      delete ruleObj.presetRuleId;
      delete ruleObj.presetRuleKey;
      delete ruleObj.assetGroups;
    }
    return ruleObj;
  }

  compareFormDataValue(ruleObj) {
    /*This is to avoid circular JSOn error caused by chooseSecurityType. Using secCats to check for any changes in securities*/
    const latestFormObj = this.attributesForm.getRawValue();
    delete latestFormObj.chooseSecurityType;
    /*Comparing sec categaries to make put call if any differences*/
    const compareSecCategories = this.compareSecCategories(latestFormObj, ruleObj);

    latestFormObj.assetGroups = this.toRemoveOrderValueFromAssetGrpObj(latestFormObj.assetGroups);

    if (latestFormObj.assetGroups && latestFormObj.assetGroups.length > 0) {
      latestFormObj.assetGroups.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
      latestFormObj.assetGroups.forEach(latAttrbts => {
        latAttrbts.attributes.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
      });
    }

    this.formObjToCompare.assetGroups = this.toRemoveOrderValueFromAssetGrpObj(this.formObjToCompare.assetGroups);

    if (this.formObjToCompare.assetGroups && this.formObjToCompare.assetGroups.length > 0) {
      this.formObjToCompare.assetGroups.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
      this.formObjToCompare.assetGroups.forEach(formAttrbts => {
        formAttrbts.attributes.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
      });
    }

    /* Preset selection is managed outside form controls; compare it explicitly.
       Use a dedicated snapshot for the initial value so it cannot be mutated
       by radio-switch handlers that update attributesFormData. */
    const normalize = (value: any) => (value === undefined || value === null || value === '') ? '' : String(value);
    const hasPresetSelectionChanged = normalize(this.presetRuleId) !== normalize(this.initialPresetRuleId);

    return (JSON.stringify(latestFormObj) !== JSON.stringify(this.formObjToCompare) || compareSecCategories || hasPresetSelectionChanged);
  }

  toRemoveOrderValueFromAssetGrpObj(assetGroups) {
    if (assetGroups && assetGroups.length > 0) {
      assetGroups = assetGroups.map(group => {
        const { order, ...restOfAsstGrps } = group;
        if (restOfAsstGrps.attributes && Array.isArray(restOfAsstGrps.attributes)) {
          restOfAsstGrps.attributes = restOfAsstGrps.attributes.map(attr => {
            const { order, ...attrRest } = attr;
            return attrRest;
          });
        }
        return restOfAsstGrps;
      });
    }
    return assetGroups;
  }

  goToNextStep() {
    if (!this.dateError) {
      this.isClicked = false;
      this.defaultSaveSuccess = true;
      const isRBSOrGlobal = this.businessUnit === this.getSharedConstant.rbsBUText || this.attributesFormData.globalRule;
      if (isRBSOrGlobal && this.attributesFormData.appliesTo === 'OPT') {
        this.attributesFormData.appliesTo = 'DV';
        this.attributesForm.patchValue({ appliesTo: 'DV' });
      }
      this.saveData(true);
      const ruleObj = this.deleteFormValues();
      delete ruleObj.chooseSecurityType;
      delete ruleObj.oldRusleIdForCopy;
      delete ruleObj.isEmpGrpModified;

      if (!this.is10b5Client) {
        delete ruleObj.planId;
        /* Preserve the Special Blackout sub category for non-10b5 clients; only 10b5-1/plan-based
           sub categories should be stripped here (Open Brokerage is re-added later when applicable). */
        if (ruleObj.ruleSubCategory !== this.getSharedConstant.specialBlackout.subType) {
          delete ruleObj.ruleSubCategory;
        }
        delete ruleObj.isSavedAsDraft;
      }

      if (this.attributesFormData.ruleType === this.getConstant.rulesConstant.autoComplete.FNDISUTxt) {
        ruleObj.fndFmly = this.emtrService.formFundFamily(ruleObj.fndFmlyInfo);
        delete ruleObj.appliesTo;
        delete ruleObj.indSecs;
        delete ruleObj.instrumentGroups;
        delete ruleObj.rstrctShortSell;
        delete ruleObj.fndFmlyInfo;
      } else {
        delete ruleObj.fndFmlyInfo;
        delete ruleObj.fndFmly;
      }
      /* Setting Action in Request Payload only for Copy/New Rule */
      if (ruleObj.mode === 'Copy') {
        ruleObj.action = 'COPY';
        ruleObj.ruleAssignInfo = {};
      } else if (ruleObj.mode === '') {
        ruleObj.action = 'NEW';
      }

      const differenceInformVal = this.compareFormDataValue(ruleObj);
      if ((this.ruleService.checkIfChangesMadeInStep1 || this.ruleService.checkIfChangesMadeInStep2 ) || differenceInformVal) {
        if (this.businessUnit === this.getSharedConstant.rbsBUText || this.businessUnit === '') {
          delete ruleObj.name;
        }
        if (this.attributesFormData.globalRule) {
          const isSuperRestriction = this.attributesFormData.isSuperRestriction === 'Y';
          const isGlobal = this.isGlobalRule(ruleObj);
          const globalConfig = isSuperRestriction || !isGlobal
            ? this.getConstant.rulesConstant.semiGlobalObj
            : this.getConstant.rulesConstant.globalObj;

          ruleObj.global = { ...globalConfig };
          delete ruleObj.orgId;
        } else {
          delete ruleObj.global;
        }
        delete ruleObj.globalRule;
        delete ruleObj.micAGSelectedFlag;
        delete ruleObj.employeeAccounts;

        ruleObj.custom = this.customVal;

        const localObj = this.attributesForm.getRawValue();
        if (localObj.assetGroups && localObj.assetGroups.length > 0) {
          delete ruleObj.secCatgs1;
          delete ruleObj.secCatgs2;
          delete ruleObj.secCatgs3;
        }

        this.formDataService.formData.showToast = true;
        if (ruleObj.mode === '' || ruleObj.status === 'DRAFT'){
          delete ruleObj.ngOmsRuleInfo;
        }
        const ruleName = this.ruleService.globalOrSemiGlobalRuleName;
        if (this.validateRoleForOBP()) {
          ruleObj.ruleSubCategory = this.getSharedConstant.openBrokerage.subType;
          delete ruleObj.toEnableOpenBrokeragePlan
        }
        this.ruleService.saveRule(ruleObj, ruleName).subscribe((res) => {
          /* Reset persisted step-change flags only after saveRule succeeds so a failed
             save leaves the "dirty" state intact for retry. */
          this.ruleService.checkIfChangesMadeInStep1 = false;
          this.ruleService.checkIfChangesMadeInStep2 = false;
          if (this.isModified || this.isViolated) {
            this.sharedService.closeModal('delete-confirmation-modal');

            if (this.isViolated) {
              const customAssetGroupData = this.ruleService.presetRulesCache().find(ele => ele.key === this.getConstant.presetRules.customAssetGroupText);
              this.presetRuleKey = customAssetGroupData?.key;
              this.presetRuleId = customAssetGroupData?.id;
              /* Preset has been violated and downgraded to Custom Asset Group — reset custom flag */
              this.customVal = false;
            }
          }
          /* Clearing Error Message after clicking Save & Continue in Step2 */
          this.ruleService.showSchError.emit(false);
          this.ruleService.schErrorMsg.emit([]);
          this.defaultSaveSuccess = false;

          /* Setting startDt/endDt/status in Edit scenario and Active Status for Production Bug #16815 */
          if (this.formDataService.formData.mode === this.getConstant.rulesConstant.editCapsTxt && res.data.status === this.getConstant.rulesConstant.ruleActiveStatus) {
            this.formDataService.formData.startDt = (res.data && res.data.startDt) ? res.data.startDt : '';
            this.formDataService.formData.endDt = (res.data && res.data.endDt) ? res.data.endDt : '';
            this.formDataService.formData.status = (res.data && res.data.status) ? res.data.status : '';
          }
          /* appending copy when new copy rule is created and removing it when rule engine has given new name */
          if (this.businessUnit === this.getSharedConstant.rbsBUText && this.attributeData.mode === 'Copy' && this.ruleService.oldRBSRuleNameForCopyFlow === '') {
            this.ruleService.originalRBSRuleNameForCopyFlow = res.data.name;
            this.ruleService.oldRBSRuleNameForCopyFlow = res.data.name;
          } else if (this.businessUnit === this.getSharedConstant.rbsBUText && (this.attributeData.mode === 'Copy' || this.attributeData.mode === '') && this.ruleService.oldRBSRuleNameForCopyFlow !==  res.data.name) {
            this.ruleService.originalRBSRuleNameForCopyFlow = res.data.name;
            this.ruleService.oldRBSRuleNameForCopyFlow = res.data.name;
          }
          this.formDataService.formData.expiredRuleStatus = res.data.status;
          this.formDataService.formData.employeeGroups = (res.data.employeeGroups && res.data.employeeGroups.length > 0) ? res.data.employeeGroups : this.formDataService.formData.employeeGroups;
          this.formDataService.formData.isSavedAsDraft = true;
          this.formDataService.setId((ruleObj.id) ? ruleObj.id : res.data.id);
          this.formDataService.setRuleName(res.data.name ? res.data.name : ruleObj.data);
          if (this.formDataService.formData.mode === '') {
            /* Save & Continue button click GUTtracking value for adobe analytics - Only in create flow */
            this.sharedService.gutTracking('adobe-lc_rule_step2continue');
          }
          this.router.navigate(['../step3'], {relativeTo: this.r});
        }, error => {
          /* Disable Save & Continue only for the specific 'no options restriction' error; user must make a change to retry.
             Compare in lowercase so minor casing differences in the backend message don't break the check. */
          const errorMessage = error.error?.errorResponse?.errorMessage;
          if (this.formDataService.formData.mode === this.getConstant.rulesConstant.editCapsTxt &&
            errorMessage && errorMessage.toLowerCase() === this.getConstant.ruleSteps.step2.noOptionsRestrictionErrorMsg.toLowerCase()) {
            this.disableSaveAfterError = true;
          }
          if (this.isModified || this.isViolated) {
            this.invalidErrorMessage.next(error.error?.errorResponse?.errorMessage);
            this.sharedService.clearErrorMessage();
          }
        });
      } else {
        this.formDataService.formData.showToast = false;
        if (this.formDataService.formData.mode === '') {
          /* Save & Continue button click GUTtracking value for adobe analytics - Only in create flow */
          this.sharedService.gutTracking('adobe-lc_rule_step2continue');
        }
        this.router.navigate(['../step3'], {relativeTo: this.r});
      }
    }
  }

  /* Handling the Save from confirm-message clicking 'Yes' */
  goToPreviousStep() {
    if (this.errorMsg.length === 0 || (this.errorMsg.length === 1 && this.errorMsg[0] === this.getConstant.rulesConstant.autoComplete.noRecords)) {
      this.saveData(false);
      const ruleObj = this.deleteFormValues();
      this.isClicked = false;
      /* This is to identify changes made in step 2 and came back to step1. If this is not put, new changes are not identified hence to put call is made*/
      this.ruleService.checkIfChangesMadeInStep2 = this.compareFormDataValue(ruleObj);
      this.ruleService.previousStep = true;
      this.navigateTo('../step1', '');
    }
  }

  compareSecCategories(latestFormObj, ruleObj) {
    const latestSecCategoriesVal = [];
    const comapareSecCategories = false;
    if (this.attributesFormData.ruleType === 'SECTYP') {
      latestSecCategoriesVal.push(ruleObj.secCatgs1);
      latestSecCategoriesVal.push(ruleObj.secCatgs2);
      latestSecCategoriesVal.push(ruleObj.secCatgs3);
      if (latestSecCategoriesVal.length > 0) {
        latestSecCategoriesVal.forEach(latSecCat => {
          latSecCat.sort((a, b) => (a.secTypNm > b.secTypNm) ? 1 : ((b.secTypNm > a.secTypNm) ? -1 : 0));
        });
      }
      if (this.allSecCategories.length > 0) {
        this.allSecCategories.forEach(allSecCat => {
          allSecCat.sort((a, b) => (a.secTypNm > b.secTypNm) ? 1 : ((b.secTypNm > a.secTypNm) ? -1 : 0));
        });
      }
      if (JSON.stringify(latestSecCategoriesVal) !== JSON.stringify(this.allSecCategories)) {
        return true;
      }
    }
  }

  saveData(validateStep) {
    const formObj = this.attributesForm.getRawValue();
    const fromDate = this.validateRoleForOBP('edit') ? this.getCurrentDate : this.attributesForm.get('dateFrom').value;
    const toDate = this.attributesForm.get('dateTo').value;
    /* eslint-disable-next-line max-len */
    formObj.startDt = (fromDate.date) ? (moment.tz(moment(new Date(moment(fromDate.date).format('YYYY/MM/DD') + ' ' + fromDate.time + ' ' + fromDate.timeMeridian).getTime()).format('YYYY MM DD HH:mm'), 'YYYY-MM-DDTHH:mm:ss.SSS', 'America/New_York').format('YYYY-MM-DDTHH:mm:ss.SSS')) : '';

    /* eslint-disable-next-line max-len */
    formObj.endDt = (toDate.date) ? moment.tz(moment(new Date(moment(toDate.date).format('YYYY/MM/DD') + ' ' + toDate.time + ' ' + toDate.timeMeridian).getTime()).format('YYYY MM DD HH:mm'), 'YYYY-MM-DDTHH:mm:ss.SSS', 'America/New_York').format('YYYY-MM-DDTHH:mm:ss.SSS') : '';
    formObj.restrictBuys = (formObj.restrictBuys && formObj.restrictBuys === true) ? 'Y' : 'N';

    formObj.restrictSells = (formObj.restrictSells && formObj.restrictSells === true) ? 'Y' : 'N';
    formObj.restrictShortSells = (this.attributesForm.get('restrictShortSells').value === true) ? 'Y' : 'N';
    /*When operation net expense ration dropdown has value*/
    if (this.selectedDropDownVal) {
      let obj: any = {};
      obj = {
        name: this.getConstant.ruleSteps.step2.operatingNetExpenseRatio,
        code: this.selectedDropDownVal.code,
        value: this.selectedDropDownVal.value,
      };
      if (this.assetGroups.some(val => val.code === this.getConstant.ruleSteps.step2.mutualFundsCode)) {
        this.assetGroups.forEach(data => {
          if (data.code === this.getConstant.ruleSteps.step2.mutualFundsCode) {
            const IsExitint = data.attributes.filter( assets => assets.code === obj.code );
            if ( IsExitint.length === 0 ) {
               data.attributes.push(obj);
            }
          }
        });
      } else {
        this.assetGroups.push({
          name: this.sharedService.mutualFundsObj.name,
          code: this.getConstant.ruleSteps.step2.mutualFundsCode,
          attributes: [obj],
          sscLevel: [{name: this.sharedService.mutualFundsObj.secCatgs2[0].secTypNm, code: this.sharedService.mutualFundsObj.secCatgs2[0].secTypCd, sscLevel: 'SC2'}],
        });
      }
    }
    /* Selected Type is Security-Type saving selected Securities in formObj*/
    if (this.attributesFormData.ruleType === 'SECTYP') {
      this.formingJson(this.multiLevelUpdatedList, false);
    }
    formObj.secCatgs1 = this.attributesFormData.secCatgs1;
    formObj.secCatgs2 = this.attributesFormData.secCatgs2;
    formObj.secCatgs3 = this.attributesFormData.secCatgs3;
    formObj.rulesCategory = this.attributeData.rulesCategory;
    formObj.multiselectSelectedData = this.multiselectSelectedData;
    formObj.multiselectSelectedInstGrpData = this.multiselectSelectedInstGrpData;

    formObj.presetRuleId = this.presetRuleId;
    formObj.presetRuleKey = this.presetRuleKey;
    formObj.assetGroups = this.assetGroups;
    formObj.micAGSelectedFlag = this.setMicAGFlag;

    if (this.attributesFormData.ruleType !== this.getConstant.rulesConstant.autoComplete.FNDISUTxt) {
      formObj.fndFmlyInfo = [];
      formObj.fndFmly = [];
      this.attributesForm.patchValue({
        fndFmlyInfo: []
      });
    } else {
      this.attributesForm.patchValue({
        indSecs: []
      });
    }
    if (this.attributesFormData.ruleType !== 'SECTYP') {
      formObj.indSecs = this.attributesForm.get('indSecs').value;
      formObj.instrumentGroups = this.attributesForm.get('instGrps').value;
      formObj.fndFmlyInfo = this.attributesForm.get('fndFmlyInfo').value;
      formObj.fndFmly = this.emtrService.formFundFamily(this.attributesForm.get('fndFmlyInfo').value);
    }

    if (this.attributesFormData.globalRule) {
      const ruleObj: any = { ...this.formDataService.getFormData() };
      const isGlobal = this.isGlobalRule(ruleObj);
      formObj.global = isGlobal ? {...this.getConstant.rulesConstant.globalObj} : {...this.getConstant.rulesConstant.semiGlobalObj};
    }
    this.formDataService.setStep2(formObj, validateStep);
  }

  restrictTypeChanged() {
    const formObj = this.attributesForm.value;
    const restrictShortSells = this.attributesForm.get('restrictShortSells').value;
    this.attributesForm.get('validateRestrictType').setValue((formObj.restrictBuys || formObj.restrictSells || restrictShortSells) ?
      true : '');
  }

  navigateTo(path, message) {
    this.confirmMessage.message = message;
    this.router.navigate([path], { relativeTo: this.r });
  }

  displayErrorAutocomplete(errorMsg) {
    if (errorMsg.msg === this.getConstant.rulesConstant.autoComplete.duplicateRecord || errorMsg.msg === this.getConstant.rulesConstant.autoComplete.instrumentGroupDuplicateRecord) {
      /*To show the duplicate record information msg*/
      this.ruleService.toastType.emit('info');
      this.ruleService.toastMsg.emit(errorMsg.msg);
    } else {
      this.indSecsDuplicateErr = errorMsg.msg;
      this.ruleService.toastType.emit('');
      errorMsg?.securities ? this.ruleService.toastMsg.emit('') : this.ruleService.toastMsg.emit(errorMsg.msg);
    }

    /*To show 'No Records Found' error msg*/
    if (this.indSecsDuplicateErr) {
      this.indSecsDuplicateErrMsg = this.indSecsDuplicateErr;
      /*Push the component name in array when error is generated and it is not already present in the array*/
      if (this.componentName.indexOf(errorMsg.component) === -1) {
        this.componentName.push(errorMsg.component);
      }
      if (this.errorMsg.indexOf(this.indSecsDuplicateErr) === -1) {
        this.errorMsg.push(this.indSecsDuplicateErr);
      }
      this.ruleService.showSchError.emit(true);
    } else {
      /*Splice the component name out of the array when search field is cleared*/
      if (this.componentName.indexOf(errorMsg.component) !== -1) {
        this.componentName.splice(this.componentName.indexOf(errorMsg.component), 1);
      }
      if (this.indSecsDuplicateErrMsg && this.componentName.length === 0) {
        if (this.errorMsg.indexOf(this.indSecsDuplicateErrMsg) !== -1) {
          this.errorMsg.splice(this.errorMsg.indexOf(this.indSecsDuplicateErrMsg), 1);
          this.componentName = [];
        }
      }
    }

    /*Hide the error block when errorMsg is empty*/
    if (this.errorMsg.length === 0) {
      this.ruleService.showSchError.emit(false);
    }

    this.ruleService.schErrorMsg.emit(this.errorMsg);
  }

  displayErrorDate(errorMsg) {
    this.dateError = errorMsg;

    /*To show date error on top of the step wizard*/
    if (this.dateError) {
      /*To remove the previously displayed date error from errorMsg and replace it with new error msg*/
      if (this.dateErrorMsg) {
        if (this.errorMsg.indexOf(this.dateErrorMsg) !== -1) {
          this.errorMsg.splice(this.errorMsg.indexOf(this.dateErrorMsg), 1);
        }
      }
      this.dateErrorMsg = this.dateError;
      if (this.errorMsg.indexOf(this.dateError) === -1) {
        this.errorMsg.push(this.dateError);
      }
      this.ruleService.showSchError.emit(true);
    } else {
      if (this.dateErrorMsg) {
        if (this.errorMsg.indexOf(this.dateErrorMsg) !== -1) {
          this.errorMsg.splice(this.errorMsg.indexOf(this.dateErrorMsg), 1);
        }
      }
    }

    /*Hide the error block when errorMsg is empty*/
    if (this.errorMsg.length === 0) {
      this.ruleService.showSchError.emit(false);
    }

    this.ruleService.schErrorMsg.emit(this.errorMsg);
  }

  updateMultiselectValues(selecteddata) {
    this.multiselectSelectedData = selecteddata;
  }

  /* Validating selectedObj and formObj both are equal not updating the formObj*/
  isEquivalent(a, b) {
    // Create arrays of property names
    const aProps: any = Object.getOwnPropertyNames(a);
    const bProps: any = Object.getOwnPropertyNames(b);
    return aProps.length !== bProps.length;
  }

  /* Forming the Json while clicking Save&Continue in security-type*/
  formingJson(selectedValues, updatedlistFlag) {
    if (!this.assetGroups || (this.assetGroups && this.assetGroups.length === 0)) {
      const wholeArray = selectedValues;
      let responseArray = this.attributesFormData.chooseSecurityType;
      if (responseArray === undefined) {
        responseArray = selectedValues;
      }
      this.attributesFormData.secCatgs1 = [];
      this.attributesFormData.secCatgs2 = [];
      this.attributesFormData.secCatgs3 = [];
      Object.keys(wholeArray).forEach(key => {
        wholeArray[key].forEach(keys => {
          if (keys.data.level === 'SC1') {
            this.attributesFormData.secCatgs1.push({
              secTypNm: keys.data.desc,
              secTypCd: keys.data.code,
            });
          } else if (keys.data.level === 'SC2') {
            this.attributesFormData.secCatgs2.push({
              secTypNm: keys.data.desc,
              secTypCd: keys.data.code,
            });
          } else if (keys.data.level === 'SC3') {
            this.attributesFormData.secCatgs3.push({
              secTypNm: keys.data.desc,
              secTypCd: keys.data.code,
            });
          }
        });

      });
    } else {
      this.attributesFormData.secCatgs1 = [];
      this.attributesFormData.secCatgs2 = [];
      this.attributesFormData.secCatgs3 = [];
    }
    this.attributesFormData.secCatgs1 = this.attributesFormData.secCatgs1.reduce((unique, o1) => {
      if (!unique.some(objCat1 => objCat1.secTypCd === o1.secTypCd && objCat1.secTypNm === o1.secTypNm)) {
        unique.push(o1);
      }
      return unique;
    }, []);
    this.attributesFormData.secCatgs2 = this.attributesFormData.secCatgs2.reduce((uniqueVal, o2) => {
      if (!uniqueVal.some(objCat2 => objCat2.secTypCd === o2.secTypCd && objCat2.secTypNm === o2.secTypNm)) {
        uniqueVal.push(o2);
      }
      return uniqueVal;
    }, []);
    this.attributesFormData.secCatgs3 = this.attributesFormData.secCatgs3.reduce((uniqueValue, o3) => {
      if (!uniqueValue.some(objCat3 => objCat3.secTypCd === o3.secTypCd && objCat3.secTypNm === o3.secTypNm)) {
        uniqueValue.push(o3);
      }
      return uniqueValue;
    }, []);

    if(updatedlistFlag)
    return this.attributesFormData
  }

  /*removeDuplicateItem(data) {
    let array = [];
    data.reduce((unique, o) => {
      if (!unique.some(obj => obj.secTypCd === o.secTypCd && obj.secTypNm === o.secTypNm)) {
        unique.push(o);
      }
      array = unique;
    }, []);
    return array;
  }
*/
  /* Setting the formObj and displaying the selected Data in Page*/
  updateSecurityValues(selectedValues) {
    this.multiLevelSecurityType = Object.assign({}, selectedValues);
    const wholeArray = Object.assign({}, this.multiLevelSecurityType);
    Object.keys(wholeArray).forEach(key => {
      wholeArray[key].forEach(keys => {
        if (keys.children) {
          keys.data.selected = 'ALL';
          keys.children.forEach(record => {
            wholeArray[key] = wholeArray[key].filter(item => item.data.code !== record.data.code);
          });
        }
      });
    });
    this.multiLevelUpdatedList = wholeArray;
    this.attributesForm.patchValue({ chooseSecurityType: selectedValues });
    this.attributesForm.markAsDirty();
    this.selectedSecurityType = selectedValues;
    return Object.keys(this.multiLevelSecurityType).length > 0 ? this.multiLevelSecurityType : false;
  }

  /* Selected Security Type is 0 showing the error message*/
  selectedCapacity(data) {
    return Object.keys(data).length;
  }

  /* Performing SSC call while clicking Security Button */
  openSecurityType(event: Event) {
    if (this.securityData.length > 0) {
      this.childSecurityType.openModal(event, this.securityData);
    } else {
      this.getSecuritiesForSelectedRuleType(event, false);
    }
  }

  recurrsive(data, array) {
    if (data.subLevels) {
      data.subLevels.forEach((subLevel) => {
        if (subLevel.subLevels) {
          array.push({ ...subLevel });
          this.recurrsive(subLevel, array);
        } else {
          array.push({ ...subLevel });
        }
      });
      return array;
    } else {
      return data;
    }
  }

  populateSecurityTypeData() {
    if (!this.assetGroups && (this.attributesForm.get('assetGroups').value && this.attributesForm.get('assetGroups').value.length === 0)) {
      const isRestrictShortSellsChecked = (this.attributesForm.get('restrictBuys').value || this.attributesForm.get('restrictSells').value) ? false : this.attributesForm.get('restrictShortSells').value;
      this.ruleService.getSecurities(isRestrictShortSellsChecked).subscribe((data: any) => {
        const securityData = data.esoLevels;
        if (securityData) {
          const secCatgs1 = this.formatSecurities(this.formDataService.formData.secCatgs1, 'SC1');
          const secCatgs2 = this.formatSecurities(this.formDataService.formData.secCatgs2, 'SC2');
          const secCatgs3 = this.formatSecurities(this.formDataService.formData.secCatgs3, 'SC3');
          const selectedValues = secCatgs1.concat(secCatgs2).concat(secCatgs3);
          selectedValues.forEach(selectedData => {
            securityData.forEach(secData => {
              if (JSON.stringify(secData).indexOf('\"code\":\"' + selectedData.data.code + '"') !== -1) {
                if (!this.multiLevelSecurityType[secData.desc]) {
                  this.multiLevelSecurityType[secData.desc] = [];
                }
                if (selectedData.data.level === 'SC1') {
                  this.multiLevelSecurityType[secData.desc] = this.multiLevelSecurityType[secData.desc]
                    .concat(this.childSecurityType.formatJson(this.recurrsive({...secData}, [])))
                    .concat(this.childSecurityType.formatJson([{...secData}]));
                } else if (selectedData.data.level === 'SC2') {
                  secData.subLevels.forEach(secSubLevelData => {
                    if (JSON.stringify(secSubLevelData).indexOf('\"code\":\"' + selectedData.data.code + '"') !== -1) {
                      this.multiLevelSecurityType[secData.desc] = this.multiLevelSecurityType[secData.desc]
                        .concat(this.childSecurityType.formatJson(this.recurrsive({...secSubLevelData}, [])))
                        .concat(this.childSecurityType.formatJson([{...secSubLevelData}]));
                    }
                  });
                } else {
                  this.multiLevelSecurityType[secData.desc] = this.multiLevelSecurityType[secData.desc]
                    .concat(this.childSecurityType.formatJson([selectedData.data]));
                }
              }
            });
          });
          this.updateSecurityValues(this.multiLevelSecurityType);
        }
      });
    }
  }

  formatSecurities(securities, level) {
    return securities.map(item => {
      return {
        data: {
          desc: item.secTypNm,
          code: item.secTypCd,
          level
        }
      };
    });
  }

  ngOnDestroy(): void {
    if (this.currentOrgSubscription) {
      this.currentOrgSubscription.unsubscribe();
    }
    if (this.saveErrorSubscription) {
      this.saveErrorSubscription.unsubscribe();
    }
    this.ruleService.schErrorMsg.emit([]);
    this.ruleService.showSchError.emit(false);
    this.ruleService.toastMsg.emit('');
    this.ruleService.toastType.emit('');
    this.ruleService.showRequestIdError.emit(false);
    this.sharedService.isModalOpened.next(false);
    this.ruleService.globalOrSemiGlobalRuleName = '';
    this.ruleService.globalRuleInfo = null; // Clean up global rule info
  }

  updateInstrumentGroups(instrumentGrps) {
    if (this.attributesFormData) {
      this.attributesForm.patchValue({ instGrps: instrumentGrps });
      /* Setting the Form to Dirty if Autocomplete Record is selected */
      this.attributesForm.markAsDirty();
      if (this.attributesForm.get('instGrps').value && this.attributesForm.get('instGrps').value.length > 0) {
        this.selectedInstrumentGroups = true;
      } else {
        this.selectedInstrumentGroups = false;
      }
    }
  }

  updateMultiselectInstGrpValues(selecteddata) {
    this.multiselectSelectedInstGrpData = selecteddata;
  }

  checkIfFormIsValid() {
    const assetGroupsVal = this.attributesForm.get('assetGroups') ? this.attributesForm.get('assetGroups').value : [];
    const hasSelectedAssetGroups = Array.isArray(assetGroupsVal) && assetGroupsVal.length > 0;

    /* Validate form to enable or disable Save and Continue btn when Security Type is Selected  */
    if (this.attributesFormData.ruleType === 'SECTYP') {
      if (this.formDataService.formData.mode === '' && this.formDataService.formData.ruleSubCategory === this.getSharedConstant.openBrokerage.subType) {
        const result = (this.attributesForm.get('restrictSells').value || this.attributesForm.get('restrictBuys').value) ? true : '';
        this.attributesForm.patchValue({ validateRestrictType: result });
      }
        /* Enable or disable Save and Continue btn for choose Security Type List flow */
      return !(this.attributesForm.valid && ((this.selectedSecurityType && Object.keys(this.selectedSecurityType).length !== 0) || hasSelectedAssetGroups));
    }
    return !(this.attributesForm.get('validateRestrictType').value === true && (this.selectedIndividualSecurity || this.selectedInstrumentGroups) &&
      this.attributesForm.get('dateFrom').get('date').value && this.attributesForm.get('appliesTo').valid &&
      /* eslint-disable-next-line max-len */
      ((this.attributesForm.get('datepickerDisabled').value === false || this.attributesForm.get('datepickerDisabled').value === '') ? true : (this.attributesForm.get('dateTo').get('date').value !== '' && this.attributesForm.get('dateTo').get('date').value !== null)));
  }

  setSelectedPresetRule(event) {
    if(!event) {
      const customAssetGroupId = this.ruleService.presetRulesCache().find(data => data.name === 'Customized Asset Group')?.id;
      this.presetRuleId = customAssetGroupId;
    } else {
      this.presetRuleId = event;
    }

  }

  setSelectedAssetGroups(event) {
    this.assetGroups = event;
     this.attributesForm.patchValue({assetGroups: event});
  }
  /* Custom flag will be set to true for MF preset rules and fore rest all selection custom flag will be set to false */
  setCustomValue(event) {
    this.customVal = event;
  }

  setSelectedDropdownVal(event) {
    this.selectedDropDownVal = event;
  }

  showWarningMsg(event) {
    if (this.attributesFormData.ruleSubCategory !== this.getSharedConstant.openBrokerage.subType) {
      this.warningMsg = event;
      /* To show the warning msg when changes made in asset groups */
      this.ruleService.toastType.emit('warn');
      this.ruleService.toastMsg.emit(this.warningMsg);
    }
  }

  displayWarningMsg() {
    this.ruleService.toastType.emit('warn');
    this.ruleService.toastMsg.emit(this.presetRuleWarnMsg);
  }

  selectRadioOption(value: string) {
    this.showSecurityOrPreset = value;
    this.clearFormOnRadioSelection();
  }

  clearFormOnRadioSelection() {
    this.displayWarningMsg();
    setTimeout(()=> {
    if (this.showSecurityOrPreset === this.getConstant.ruleSteps.step2.step2PresetRuleConditionText) {
      this.assetGroupsInput = [];
      this.attributesForm.get('chooseSecurityType').reset();
      this.ruleService.presetRuleRadioSelected.next(false);
      this.updateSecurityValues(this.attributesForm.value.chooseSecurityType);
      this.attributesForm.get('chooseSecurityType').clearValidators();
      this.attributesForm.get('assetGroups').setValidators(Validators.required);
      this.attributesForm.get('assetGroups').updateValueAndValidity();
      this.attributesForm.get('chooseSecurityType').updateValueAndValidity();
    } else if (this.showSecurityOrPreset === 'secLevel') {
      /* Custom flag will be set to true for MF preset rules selection only and for Security Level Lists selection custom flag will be set to false */
      this.customVal = false;
      this.attributesFormData.presetRuleKey = this.getConstant.presetRules.customAssetGroupText;
      this.attributesFormData.presetRuleId = null;
      this.assetGroupsInput = this.assetGroups = [];
      this.selectedDropDownVal = null;
      this.presetRuleId = null;
      this.presetRuleKey = this.getConstant.presetRules.customAssetGroupText;
      this.attributesForm.get('assetGroups').reset();
      this.ruleService.presetRuleRadioSelected.next(true);
      this.attributesForm.get('assetGroups').clearValidators();
      this.attributesForm.get('chooseSecurityType').setValidators(Validators.required);
      this.attributesForm.get('chooseSecurityType').updateValueAndValidity();
      this.attributesForm.get('assetGroups').updateValueAndValidity();
    }
    });
  }

  setSelectedPresetRuleKey(event) {
    this.presetRuleKey = event;
  }

  /* New Confirmation popup for prededined preset rules for RBS */
  confirmationPopup() {
    // modify or violation popup for global and semi- global rules
    if((this.attributesFormData.globalRule || this.attributesFormData.isSuperRestriction === 'Y') && this.attributesFormData.mode === this.getConstant.rulesConstant.editCapsTxt
      && this.attributesFormData.status !== 'EXPIRED') {
       this.compareLatestModifications();
     if(this.isViolated){
      this.globalSemiGlobalConfirmationMsg = this.getConstant.ruleSteps.step2.violationConfirmationMsg;
      this.modifyOrVoilationConfirmationModal.openModal(this.attributesFormData);
      }
       else if(this.isModified){
       this.globalSemiGlobalConfirmationMsg = (this.attributesFormData.isSuperRestriction === 'Y' && !this.attributesFormData.globalRule) ? this.getConstant.ruleSteps.step2.modifySuperRuleConfirmationMsg : this.getConstant.ruleSteps.step2.modifyConfirmationMsg ;
        this.modifyOrVoilationConfirmationModal.openModal(this.attributesFormData);
      }
      else {
        this.goToNextStep();
      }
    }
    // popup for client level rules
    else{
    if (this.showSecurityOrPreset === this.getConstant.ruleSteps.step2.step2PresetRuleConditionText && this.businessUnit === this.getSharedConstant.rbsBUText &&
        (this.attributesFormData.ruleType === this.getConstant.rulesConstant.ruleGlobalConst.securityTypeRule )) {
      const assestGroupOfSelectedPresetRule = this.normalizeAssetGroupArray(this.ruleService.presetRulesCache().find(ele => ele.id === this.presetRuleId)?.assetGroups);
      const selectedAssetGroup = this.normalizeAssetGroupArray(this.assetGroups);
      /* checking if anything removed from default assest group for selected preset rules.
      this function will return false if anything removed from default assets groups otherwise it will return true */
      const hasAssetGroupNotRemoved = this.compareAssetsGroups(assestGroupOfSelectedPresetRule, selectedAssetGroup);
      if (!hasAssetGroupNotRemoved) {
        const confirmObj = {
          header: `${this.getSharedConstant.confirmationDialog.title}`,
          message: this.getConstant.ruleSteps.step2.predefinedRestrictionsconfirmationMsg,
          acceptBtn: this.getSharedConstant.confirmationDialog.acceptBtn,
          rejectBtn: this.getSharedConstant.confirmationDialog.rejectBtn,
          closeIconButton: false
        };
        new Observable<boolean>((observer: Observer<boolean>) => {
          this.confirmationMessage.showConfirmMsg(confirmObj, observer);
        }).subscribe(accept => {
          if (accept) {
            const customAssetGroupData = this.ruleService.presetRulesCache().find(ele => ele.key === this.getConstant.presetRules.customAssetGroupText);
            this.presetRuleKey = customAssetGroupData?.key;
            this.presetRuleId = customAssetGroupData?.id;
            this.goToNextStep();
          }
        });
      } else {
        this.goToNextStep();
      }
    } else {
      this.goToNextStep();
    }
  }
  }

  /* Normalized AssetGrps array like code & code value will be atrributes code array*/
  normalizeAssetGroupArray(arr) {
    return (arr || []).reduce((acc, item) => { acc[item.code] = (item.attributes || []).map(attr => attr.code); return acc; }, {});
  }

  /* Compare Normalized AssetGrps array*/
  compareAssetsGroups(defaultAgpArr, selectedAgpArr) {
    for (const rulKey in defaultAgpArr) {
      if (!selectedAgpArr[rulKey]) return false;
      if (!defaultAgpArr[rulKey].length && selectedAgpArr[rulKey].length) return false;
      for (const attrVal of defaultAgpArr[rulKey]) {
        if (!selectedAgpArr[rulKey].includes(attrVal)) return false;
      }
    }
    return true;
  }

  //Validate  Global or semiGlobal Rule Name
  validateRule(ruleName: string) {
    this.ruleService.globalOrSemiGlobalRuleName = ruleName;
    if (this.isViolated) {
      const customAssetGroupData = this.ruleService.presetRulesCache().find(ele => ele.key === this.getConstant.presetRules.customAssetGroupText);
      this.presetRuleKey = customAssetGroupData?.key;
      this.presetRuleId = customAssetGroupData?.id
    }
    this.goToNextStep();
  }

  // compare Formdata changes to display modify or violation popup for global and semi global rules
  compareLatestModifications() {
    this.isModified = (this.compareFormDataValue(this.formingJson(this.multiLevelUpdatedList, true)) || this.ruleService.checkIfChangesMadeInStep2);
    if (this.showSecurityOrPreset !== 'secLevel' && this.attributeData.ruleType !== 'INDSEC') {
      const assestGroupOfSelectedPresetRule = this.normalizeAssetGroupArray(this.ruleService.presetRulesCache().find(ele => ele.id === this.presetRuleId)?.assetGroups);
      const selectedAssetGroup = this.normalizeAssetGroupArray(this.assetGroups);
      this.isViolated = !this.compareAssetsGroups(assestGroupOfSelectedPresetRule, selectedAssetGroup);
    }
  }
  disableOBPInEditMode() {
    if (this.validateRoleForOBP()) {
      const fieldsToDisable = this.getFieldsToDisable();

      // Disable each field in the form
      fieldsToDisable.forEach(field => {
        const control = this.attributesForm.get(field);
        if (control) {
          control.disable({ onlySelf: true });
        }
      });
    }
  }
  getFieldsToDisable(): string[] {
      return [
        'restrictSells',
        'restrictBuys',
        'restrictShortSells',
        'dateFrom',
        'dateTo',
        'datepickerDisabled'
      ];
  }
  validateRoleForOBP(mode?: string): boolean {
    if (!this.formDataService.formData) {
      return false;
    }
    if (mode === 'edit') {
      return false;
    }
    const isOBPRule = this.formDataService.formData.ruleSubCategory === this.getSharedConstant.openBrokerage.subType;
    const hasOBPEntitlement = this.sharedService.checkEntitlements(
      this.entitlementConst.navUUID.ngOMS.manageGlobalRuleObp.uuid, 
      '', 
      ''
    );
    const hasGlobalRuleEntitlement = this.sharedService.checkEntitlements(
      this.entitlementConst.navUUID.emtrAccess.manageGlobalRule.uuid, 
      '', 
      ''
    );
    return isOBPRule && hasOBPEntitlement && hasGlobalRuleEntitlement;
  }
  toCreateOBPRuleAttributes(): void {
    const isOBPCreateFlow = (this.attributesFormData.ruleSubCategory === this.getSharedConstant.openBrokerage.subType
      && (this.formDataService.formData.mode === '' && this.formDataService.formData.name === ''));

    if (!isOBPCreateFlow) {
      return;
    }
    if (this.validateRoleForOBP()) {
      this.initializeOBPFormValues();
      this.initializeOBPAssetGroups();
    }
  }

  initializeOBPFormValues(): void {
    this.attributesForm.patchValue({
      dateFrom: this.getCurrentDate,
      restrictBuys: true,
      restrictSells: false,
      restrictShortSells: false,
      validateRestrictType: this.hasRestrictionsEnabled()
    });
  }

  initializeOBPAssetGroups(): void {
    this.attributesFormData.assetGroups = [];
    this.attributesFormData.presetRuleId = '';
    this.attributesFormData.presetRuleKey = '';
    this.showSecurityOrPreset = this.getConstant.ruleSteps.step2.step2PresetRuleConditionText;
  }

  hasRestrictionsEnabled(): boolean {
    return this.attributesFormData.rstrctSell === 'Y' 
      || this.attributesFormData.rstrctBuy === 'Y'
      || this.attributesFormData.rstrctShortSell === 'Y';
  }

 get getCurrentDate() {
    // Get current time in Central timezone
    const centralTime = moment.tz('America/Chicago');
    
    // Create a Date object from the Central time string to preserve the timezone context
    const centralDateString = centralTime.format('YYYY-MM-DD HH:mm:ss');
    const centralDate = new Date(centralDateString);

    return {
      date: centralDate,
      time: centralTime.format('hh:mm'),
      timeMeridian: centralTime.format('a').toUpperCase()
    };
  }

  warningMessagePresetRules(): string {
    return this.validateRoleForOBP()
      ? ''
      : this.getSharedConstant.RBS.warningMsgForPresetRulesOrSecurities;
  }

  private isGlobalRule(ruleObj: any): boolean {
    const onlyBusinessUnitSelected = this.attributesFormData.employeeGroups.length === 1 &&
      this.attributesFormData.employeeGroups[0].name === 'Business Unit' &&
      this.attributesFormData.employeeAccounts.length === 0;
    if (this.formDataService.formData.mode === '') {
      if (onlyBusinessUnitSelected) {
        return true;
      } else {
        return (ruleObj.employeeGroups.length === 0 && ruleObj.employeeAccounts.length === 0);
      }
    } else {
      // Rule editing (mode === 'EDIT' or 'Copy'):
      // First priority: Check if we have global rule info from Step 4 navigation (stored in service)
      if (this.ruleService.globalRuleInfo) {
        return this.ruleService.globalRuleInfo.type === 'GLOBAL';
      }
      // Second priority: Check the global.type property if available
      if (this.attributesFormData.global?.type) {
        return this.attributesFormData.global.type === 'GLOBAL';
      }
      // Fallback: Only use employeeGroups logic if we don't have global info
      // This handles direct edit flow (not coming from Step 4)
      if (this.attributesFormData.employeeGroups && this.attributesFormData.employeeGroups.length > 0) {
        if (onlyBusinessUnitSelected) {
          // Scenario 3: Business Unit only → Global
          return true;
        } else {
          // Scenario 4: Has other employee groups → Semi-Global
          return false;
        }
      } else if (this.attributesFormData.employeeAccounts && this.attributesFormData.employeeAccounts.length > 0) {
        // Scenario 5: Has employee accounts → Semi-Global
        return false;
      }
      return false;
    }
  }
  getSecuritiesForSelectedRuleType(event?: any, isSuperRestrictionFlow?: boolean) {
    const isRestrictShortSellsChecked = (this.attributesForm.get('restrictBuys').value || this.attributesForm.get('restrictSells').value) ? false : this.attributesForm.get('restrictShortSells').value;
    this.ruleService.getSecurities(isRestrictShortSellsChecked).subscribe((data: any) => {
      this.securityData = data.esoLevels;
      if (this.securityData && !isSuperRestrictionFlow) {
        this.childSecurityType.openModal(event, this.securityData);
      } else {
        this.childSecurityType.superRuleSecurityType(this.securityData ? this.securityData : []);
      }
    });
  }
  superRestriction() {
    const isRestrictListCategory =
      this.attributesFormData.rulesCategory ===
      this.getConstant.rulesConstant.autoComplete.RESTRICT_LST_ENGTxt;
    const isSuperRestrictionEnabled = this.attributesFormData.isSuperRestriction === 'Y';

    if (!isRestrictListCategory || !isSuperRestrictionEnabled) {
      return;
    }

    this.applySuperRestrictionDefaults();
    this.showSecurityOrPreset = 'secLevel';
    if (this.securityData?.length > 0) {
      this.childSecurityType.superRuleSecurityType(this.securityData);
    } else {
      this.getSecuritiesForSelectedRuleType('', true);
    }
  }
  // to disable for super rule
  applySuperRestrictionDefaults() {
    if (this.attributesFormData.isSuperRestriction === 'Y') {
      this.attributesForm.patchValue({
        restrictBuys: true,
        restrictSells: true,
        restrictShortSells: true,
        validateRestrictType: this.hasRestrictionsEnabled()
      });
      ['restrictBuys', 'restrictSells', 'restrictShortSells'].forEach((controlName) => {
        this.attributesForm.get(controlName)?.disable();
      });
    }
  }
}
